﻿export function dropdownClicked(element, event) {
    var dropdowns = document.getElementsByClassName("dropdown");
    var width = window.innerWidth;
    element = element.parentNode;

    if (width > 1280) {
        window.location.href = element.id;
    } else {
        if (element.classList.contains("closed")) {
            for (let dropdown of dropdowns) {
                if (dropdown.classList.contains("open")) {
                    dropdown.classList.add("closed");
                    dropdown.classList.remove("open");
                    dropdown.children[0].style.paddingBottom = "initial";
                }
                for (let child of dropdown.children[0].children) {
                    if (child.classList.contains("fa-chevron-down")) {
                        child.style.transform = null;
                    }
                }
            }
            if (event.target.classList.contains("fa-chevron-down") && width < 1280) {
                event.target.style.transform = "rotate(180deg)";
            }
            element.classList.add("open");
            element.classList.remove("closed");

            element.children[0].style.paddingBottom = "8px";
        }
        else {
            if (event.target.classList.contains("fa-chevron-down")) {
                if (width < 1280) {
                    event.target.style.transform = "rotate(0deg)";
                    
                }
                element.classList.add("closed");
                element.classList.remove("open");
                element.children[0].style.paddingBottom = "initial";
            }
            else {
                window.location.href = element.id;
            }
        }
    }
}

    export function menuToggle() {
        const menu = document.querySelector("#jsmenu");
        const links = document.getElementsByClassName("small-menu");
        menu.addEventListener("click", () => {
            for (let item of links) { item.classList.toggle("small-menu-hidden") };
        });
    }